import React, { useContext, useState, useEffect } from 'react';
import PollTab from '../postTabs/PollTab';
import PostTab from '../postTabs/PostTab';
import WebinarTab from '../postTabs/WebinarTab';
import { Modal, ModalBody } from 'reactstrap';
import ClinicalSessionTab from '../postTabs/ClinicalSessionTab';
import ClinicalStudyTab from '../postTabs/ClinicalStudyTab';
import { Language } from '../../../App';
import { TypeTab } from './PostForm';
import { IoClose } from 'react-icons/io5';
import '../postTabs/formTheme.css';

function CreatePostPopup({
  selectedLabel,
  refetch,
  selectedPost,
  editWebinar,
  setEditWebinar,
  editPost,
  setEditPost,
  show,
  onHide,
  handleApiCall,
  setProgress,
  handlePostSelect,
  updatePost,
}) {
  const { lang } = useContext(Language);
  const publishId = navigator.language.startsWith("en") ? 'Publish' : "Publicar";
  const [activeTab, setActiveTab] = useState(
    editWebinar ? lang?.webinar : editPost ? publishId : selectedLabel
  );

  useEffect(() => {
    if (editWebinar) {
      setActiveTab(lang?.webinar || "Webinar");
    } else if (editPost) {
      setActiveTab(publishId);
    }
  }, [editWebinar, editPost, lang, publishId]);

  const commonProps = {
    onHide,
    setProgress,
    handleApiCall,
    refetch,
  };

  const tabs = [
    {
      id: publishId,
      typeKey: "publish",
      title: lang?.publish || "Post",
      component: (
        <PostTab
          setEditPost={setEditPost}
          editPost={editPost}
          selectedPost={selectedPost}
          handlePostSelect={handlePostSelect}
          updatePost={updatePost}
          {...commonProps}
        />
      ),
    },
    {
      id: lang?.poll || "Poll",
      typeKey: "poll",
      title: lang?.poll || "Poll",
      component: <PollTab {...commonProps} />,
    },
    {
      id: lang?.webinar || "Webinar",
      typeKey: "webinar",
      title: lang?.webinar || "Webinar",
      component: (
        <WebinarTab
          setEditWebinar={setEditWebinar}
          refetch={refetch}
          selectedPost={selectedPost}
          editWebinar={editWebinar}
          handlePostSelect={handlePostSelect}
          {...commonProps}
        />
      ),
    },
    {
      id: lang?.clinical_study || "Clinical Study",
      typeKey: "study",
      title: lang?.clinical_study || "Clinical Study",
      component: <ClinicalStudyTab {...commonProps} />,
    },
    {
      id: lang?.clinical_session || "Clinical Session",
      typeKey: "session",
      title: lang?.clinical_session || "Clinical Session",
      component: <ClinicalSessionTab {...commonProps} />,
    },
  ];

  const activeTypeKey = tabs.find((t) => t.id === activeTab)?.typeKey || "publish";

  const handleModalClose = () => {
    onHide();
    if (setEditWebinar) {
      setEditWebinar(false);
    }
    if (setEditPost) {
      setEditPost(false);
    }
  };

  const isEditMode = Boolean(editWebinar || editPost);

  return (
    <Modal
      className="modal-lg pf-modal"
      isOpen={show}
      toggle={handleModalClose}
      centered
      backdrop="static"
    >
      {!isEditMode ? (
        <div className="pf-modal-header-wrapper">
          <div className="pf-modal-tabs">
            {tabs.map(({ id, typeKey, title }) => (
              <TypeTab
                key={id}
                label={title}
                typeKey={typeKey}
                isActive={activeTab === id}
                onClick={() => setActiveTab(id)}
              />
            ))}
          </div>
          <button
            type="button"
            className="pf-modal-close-btn"
            onClick={handleModalClose}
            aria-label="Close"
          >
            <IoClose size={18} />
          </button>
        </div>
      ) : (
        <div className="pf-modal-header-wrapper d-flex justify-content-between align-items-center">
          <h5 className="mb-0 fs-16 fw-600" style={{ color: "#0F1A2B" }}>
            {editWebinar ? (lang?.edit_webinar || "Edit Webinar") : (lang?.edit_post || "Edit Post")}
          </h5>
          <button
            type="button"
            className="pf-modal-close-btn"
            onClick={handleModalClose}
            aria-label="Close"
          >
            <IoClose size={18} />
          </button>
        </div>
      )}

      <ModalBody className={`pf-modal-body pf-scope-${activeTypeKey}`}>
        {/* Render the active tab component with smooth transition */}
        <div key={activeTab} className="pf-tab-pane-transition">
          {tabs.find(({ id }) => activeTab === id)?.component}
        </div>
      </ModalBody>
    </Modal>
  );
}

export default CreatePostPopup;
